module.exports = __webpack_public_path__ + "static/media/2020.7.10《治国理政》集中学习会.48ffc940.jpg";